export default {
  title: 'ניהול קבצים',

};
